import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "sponsors-page"
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: { groups: [], selectedGroup: null },
  mutations: {},
  actions: {},
  getters: {},

  plugins: [vuexLocal.plugin]
});
